import { isNil, reject } from "ramda"

export enum TipMethodEnum {
    Disabled = "disabled",
    Simple = "simple",
    Smart = "smart",
}

export const TIP_PERCENTAGES_COUNT = 4

export const getTippingPercentageKey = (index: number, percentagesKey: string): string => percentagesKey + index

export const getTippingPercentageKeys = (percentagesKey: string): string[] =>
    [...Array(TIP_PERCENTAGES_COUNT)].map((_, index) => getTippingPercentageKey(index, percentagesKey))

export const getTippingPercentageFormValues = (values: any, percentagesKey: string): number[] =>
    reject(
        isNil,
        [...Array(TIP_PERCENTAGES_COUNT)].map((_, index) => {
            const value = values[getTippingPercentageKey(index, percentagesKey)]
            return value ? Number(value) * 1000 : value
        })
    )
